export function addScriptInDom(script) {
    var firstScript = document.getElementsByTagName('script')[0];
    if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
    }
    else {
        document.body.appendChild(script);
    }
}
